module.exports = __webpack_public_path__ + "static/media/Yoyo_6443.23ac4b1f.jpg";